const constants = {
  PARTIAL_DWELLING: 'PARTIAL',
  ENTIRE_DWELLING: 'ENTIRE',
  INTERMEDIARY_HOMEAWAY: 'HOMEAWAY',
  INTERMEDIARY_AIRBNB: 'AIRBNB',
  STATIC_PAGE_ROUTE: '/static-pages',
  FAILED_TO_FETCH: 'Failed to fetch', // aka can't hit back end
  API_BASE: process.env.REACT_APP_API_BASE,
};

export default constants;
